import React from 'react'
import { Outlet } from 'react-router-dom'

const InterviewTracker = () => {
  return (
    <div><Outlet/></div>
  )
}

export default InterviewTracker